/** @jsxRuntime classic */
/** @jsx jsx */
import React, { useContext, useEffect, useRef, useState } from 'react'
import { fetchSetting, setSetting } from '../../Components/action/common'
import { useDispatch, useSelector } from 'react-redux'
// import { pushToSetting, setSettings } from '../../redux/slices/TaskSlice'
import {  setColorPicker, setColorPickerDark, setNewBackgroundColor, setTheme } from '../../redux/slices/ThemeSlice'
import Select from 'react-select';
import { useNavigate } from 'react-router-dom'
import { jsx } from "@emotion/core";
import { pushToSetting, setAddQuickLinkClick } from '../../redux/slices/SettingSclice'
import Image from '../../Components/Admin/Backgrounds/Image'
import Todoist from '../../Components/Integration/Todoist';
import KeyboardShortcuts from './KeyboardShortcuts';
import { AuthContext } from '../../AuthProvider';
// import GoogleCalendar from '../../Components/Integration/GoogleCalendar';

function General({ activeTab, setActiveTab }) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { setThemeMode } = useContext(AuthContext)

  // global state
  const settings = useSelector(state => state.settings.settings)
  const { colorPicker, colorPickerDark, theme, backgroundImageId, darkBackgroundImageId, backgroundImages } = useSelector(state => state.theme)
  const [backgroundImage, setBackgroundImage] = useState(null);
  const [darkBackgroundImage, setDarkBackgroundImage] = useState(null);
  const [gernalSection, setGernalSection] = useState(false)
  const [onMouseEnterGeneral, setOnMouseEnterGeneral] = useState(false)
  const [accentColors, setAccentColors] = useState([]);
  const timeFormatOptions = [
    { value: 'LT', label: '1:00 PM' },
    { value: 'HH:mm', label: '13:00' }
  ];
  const dateFormatOptions = [
    { value: 'DD/MM/YY', label: 'DD/MM/YY' },
    { value: 'MM/DD/YY', label: 'MM/DD/YY' }
  ]
  const weekStartOptions = [
    { value: 'Monday', label: 'Monday' },
    { value: 'Tuesday', label: 'Tuesday' },
    { value: 'Wednesday', label: 'Wednesday' },
    { value: 'Thursday', label: 'Thursday' },
    { value: 'Friday', label: 'Friday' },
    { value: 'Saturday', label: 'Saturday' },
    { value: 'Sunday', label: 'Sunday' }
  ]
  const themeOptions = [
    { value: 'light', label: 'Light' },
    { value: 'dark', label: 'Dark' },
    { value: 'system', label: 'Adapt to System' }
  ]
  const dailyTaskLimitOptions = [
    { value: 'No Limit', label: 'No Limit' }
  ]
  const transferTaskOptions = [
    { value: 'Transfer to Next Day', label: 'Transfer to Next Day' },
    { value: 'Transfer to Next Week', label: 'Transfer to Next Week' },
    { value: 'Transfer to Next Month', label: 'Transfer to Next Month' }
  ]
  const popover = {
    position: 'absolute',
    zIndex: '99999',
  }
  const cover = {
    position: 'fixed',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px',
  }

  useEffect(() => {
    fetchSettingData();
  }, [])

  useEffect(() => {
    console.log(backgroundImageId, darkBackgroundImageId, backgroundImages)
    if(backgroundImageId){
      const bgImage = backgroundImages.find(img => img.id == backgroundImageId);
      if(bgImage){
        setBackgroundImage(bgImage);
      }
    }
    if(darkBackgroundImageId){
      const bgImage = backgroundImages.find(img => img.id == darkBackgroundImageId);
      if(bgImage){
        setDarkBackgroundImage(bgImage);
      }
    }
  }, [backgroundImageId, darkBackgroundImageId, backgroundImages])

  const fetchSettingData = async () => {
    try {
      let response = await fetchSetting()
      dispatch(pushToSetting(response?.data?.responseData?.settings));
      dispatch(setColorPicker(response?.data?.responseData?.settings?.accentColor ?? colorPicker))
      dispatch(setColorPickerDark(response?.data?.responseData?.settings?.accentColorDark ?? colorPickerDark))
    } catch ({ response }) {

    }
  }

  const onColorChange = (mode) => {
    setThemeMode(mode)
    dispatch(setNewBackgroundColor(true))
    navigate(process.env.REACT_APP_ROOT)
  }

  const handleChange = async (value, name) => {
    if (name == "theme" && value?.value == "dark") {
      dispatch(setTheme("dark"));
    } else if (name == "theme" && value?.value == "light") {
      dispatch(setTheme("light"));
    } else if (name == "theme" && value?.value == "system") {
      dispatch(setTheme("system"));
    }

    const newSettings = { ...settings, [name]: value?.value, utcOffset: new Date().getTimezoneOffset() };
    dispatch(pushToSetting(newSettings));
    // console.log(name, value.value, { ...settings, 'testing': value?.value }); return;
    try {
      await setSetting({ "settings": newSettings })
    } catch ({ response }) { }
  }

  return (
    <li
      css={{
        '&:hover .accordion-title': {
          color: theme == "dark" ? (((theme == "dark" && colorPickerDark == "#ef233c")) ? "white !important" : (theme == "dark" && colorPickerDark == "#f8961e") ? "black !important" : (theme == "dark" && colorPickerDark == "#ffca3a") ? "black !important" : (theme == "dark" && colorPickerDark == "#27cb9a") ? "black !important" : (theme == "dark" && colorPickerDark == "#4cc9f0") ? "black !important" : "white !important") : "white !important"
        },
        '.accordion-title': {
          color: theme == "dark" ? (((theme == "dark" && colorPickerDark == "#ef233c") && (activeTab == "general")) ? "white !important" : ((theme == "dark" && colorPickerDark == "#f8961e") && (activeTab == "general")) ? "black !important" : ((theme == "dark" && colorPickerDark == "#ffca3a") && (activeTab == "general")) ? "black !important" : ((theme == "dark" && colorPickerDark == "#27cb9a") && (activeTab == "general")) ? "black !important" : ((theme == "dark" && colorPickerDark == "#4cc9f0") && (activeTab == "general")) ? "black !important" : "white !important") : "white"
        }
      }}
      className={`li-setting-tab ${activeTab == "general" ? 'active' : ''}`}>
      <div className="settings-accordion-tab"
        onClick={() => { setActiveTab(activeTab => activeTab == 'general' ? null : 'general'); dispatch(setAddQuickLinkClick(false)) }}
        style={{ background: theme == "dark" ? "black" : "" }}
        css={{
          background: activeTab == 'general' ? (theme == 'dark' ? `linear-gradient(0deg,var(--accent-color-10),var(--accent-color-10)),#000 !important` : `linear-gradient(0deg, var(--accent-color), var(--accent-color)), #ffffff !important`) :
            '',
          '&:hover': {
            background: theme == 'dark' ? `linear-gradient(0deg,var(--accent-color-10),var(--accent-color-10)),#000 !important` : `linear-gradient(0deg, var(--accent-color), var(--accent-color)), #ffffff !important`,
          }
        }}>
        <div className="settings-accordion-heading">
          <figure className="settings-icon">
            <img src="images/general.svg" className="img-default dark:invert-color" />
          </figure>
          <h3 className="accordion-title uppercase dark:text-white">General</h3>
        </div>
        <div className="settings-accordion-arrow">
          <img src="images/arrow-down.svg" className='dark:invert-color' />
        </div>
      </div>
      {

        activeTab == 'general' && <div className="settings-accordion-content">
          <div className="inner-form">
            <form className="formProfile" >
              {/* <div className="field-block">
                <h3 className="form-heading uppercase" style={{ color: theme == "dark" ? "white" : "", opacity: theme == "dark" ? 0.3 : '' }}>Date &amp; Time</h3>
                <label className="field-label" style={{ color: theme == "dark" ? "white" : "", opacity: theme == "dark" ? 0.7 : '' }}>Time zone</label>
                <div className="field-data">
                  <div className="filed-data-block">
                    <select className="select-field" name="timezone" defaultValue={settings?.timezone ?? null}>
                      <option value="UTC-12:00 International Date Line West">UTC-12:00 International Date Line West</option>
                      <option value="UTC-11:00 Coordinated Universal Time-11">UTC-11:00 Coordinated Universal Time-11</option>
                      <option value="UTC-10:00 Aleutian Islands">UTC-10:00 Aleutian Islands</option>
                      <option value="UTC-10:00 Hawaii">UTC-10:00 Hawaii</option>
                      <option value="UTC-09:30 Marquesas Islands">UTC-09:30 Marquesas Islands</option>
                      <option value="UTC-09:00 Alaska">UTC-09:00 Alaska</option>
                      <option value="UTC-09:00 Coordinated Universal Time-09">UTC-09:00 Coordinated Universal Time-09</option>
                      <option value="UTC-08:00 Baja California">UTC-08:00 Baja California</option>
                      <option value="UTC-08:00 Coordinated Universal Time-08">UTC-08:00 Coordinated Universal Time-08</option>
                    </select>
                  </div>
                </div>
              </div> */}
              <div className="field-block mt-[30px]" >
                <h3 className="form-heading uppercase" style={{ color: theme == "dark" ? "white" : "", opacity: theme == "dark" ? 0.7 : '' }}>Appearance </h3>
                <label className="field-label" style={{ color: theme == "dark" ? "white" : "", opacity: theme == "dark" ? 0.7 : '' }}>Mode</label>
                <div className="field-data">
                  <div className="filed-data-block" css={{
                    '.general-setting__option--is-selected': {
                      background: `linear-gradient(0deg, var(--accent-color), var(--accent-color)), var(--theme-mode-color-white) !important;`
                    }
                  }} >
                    <Select
                      onChange={(value) => handleChange(value, "theme")}
                      options={themeOptions}
                      defaultValue={
                        settings?.theme ? themeOptions.filter(option =>
                          option.value?.toLowerCase() === settings?.theme?.toLowerCase()
                        )?.[0] : themeOptions[0]
                      }
                      className="react-select"
                      classNamePrefix={"general-setting" || ""}
                      classNames={{control: () => 'dark:bg-black', menu: () => 'dark:bg-black', option: () => 'dark:bg-black dark:text-white', singleValue: () => 'dark:text-white'}}
                    />
                  </div>
                </div>
              </div>

              {
                (settings?.theme == "light" || settings?.theme == "system")
                &&
                <div className="field-block mt-[30px]">
                  <label className="field-label" style={{ color: theme == "dark" ? "white" : "", opacity: theme == "dark" ? 0.7 : '' }}>Light Mode Image</label>
                  <div className="field-data" style={{alignItems: "center"}}>
                    
                    <div className="field-button" css={{
                      width: "100% !important",
                      gap: "10px !important",
                      alignItems: "start !important",
                      '.image-card': {
                        width: "100%",
                        height: "auto",
                        maxHeight: "250px !important",
                        borderRadius: "15px !important",
                        minWidth: "525px",
                        minHeight: "250px"
                      }
                    }}>
                      <div className="field-data">
                        {backgroundImage && <Image location={backgroundImage?.location} colorPicker={colorPicker} theme="light" />}
                      </div>
                      <button className="changeName"
                        css={{
                          background: `linear-gradient(0deg, rgba(var(--theme-mode-rgb-white), 0.9), rgba(var(--theme-mode-rgb-white), 0.9)), linear-gradient(0deg, var(--accent-color), var(--accent-color)), linear-gradient(0deg, rgba(var(--theme-mode-rgb-white-reverse), 0.05), rgba(var(--theme-mode-rgb-white-reverse), 0.05)), var(--theme-mode-color-white) !important`,
                          color: `var(--accent-color) !important`

                        }}
                        onClick={() => onColorChange("light")}>Change</button>
                    </div>
                  </div>
                </div>
              }

              {
                (settings?.theme == "dark" || settings?.theme == "system")
                &&
                <div className="field-block mt-[30px]">
                  <label className="field-label" style={{ color: theme == "dark" ? "white" : "", opacity: theme == "dark" ? 0.7 : '' }}>Dark Mode Image</label>
                  <div className="field-data" style={{alignItems: "center"}}>
                    
                    <div className="field-button" css={{
                      width: "100% !important",
                      gap: "10px !important",
                      alignItems: "start !important",
                      '.image-card': {
                        width: "100%",
                        height: "auto",
                        maxHeight: "250px !important",
                        borderRadius: "15px !important",
                        minWidth: "525px",
                        minHeight: "250px"
                      }
                    }}>
                      <div className="field-data">
                        {darkBackgroundImage && <Image location={darkBackgroundImage?.location} colorPicker={colorPickerDark} theme="dark" />}
                      </div>
                      <button className="changeName"
                        css={{
                          background: `linear-gradient(0deg, rgba(var(--theme-mode-rgb-white), 0.9), rgba(var(--theme-mode-rgb-white), 0.9)), linear-gradient(0deg, var(--accent-color), var(--accent-color)), linear-gradient(0deg, rgba(var(--theme-mode-rgb-white-reverse), 0.05), rgba(var(--theme-mode-rgb-white-reverse), 0.05)), var(--theme-mode-color-white) !important`,
                          color: `var(--accent-color) !important`

                        }}
                        onClick={() => onColorChange("dark")}>Change</button>
                    </div>
                  </div>
                </div>
              }

              <div className="field-block mt-[30px]">
                <label className="field-label" style={{ color: theme == "dark" ? "white" : "", opacity: theme == "dark" ? 0.7 : '' }}>Other themes</label>
              </div>
              <div className="field-block mt-[30px]">
                <label className="field-label" style={{ color: theme == "dark" ? "white" : "", opacity: theme == "dark" ? 0.7 : '' }}>Time format</label>
                <div className="field-data">
                  <div className="filed-data-block" css={{
                    '.general-setting__option--is-selected': {
                      background: `linear-gradient(0deg, var(--accent-color), var(--accent-color)), #ffffff !important;`
                    }
                  }}>
                    <Select
                      onChange={(value) => handleChange(value, "timeFormat")}
                      options={timeFormatOptions}
                      value={
                        settings?.timeFormat ? timeFormatOptions.filter(option =>
                          option.value === settings?.timeFormat) : timeFormatOptions[0]
                      }
                      className="react-select"
                      containerClass=""
                      classNamePrefix={"general-setting" || ""}
                      classNames={{control: () => 'dark:bg-black', menu: () => 'dark:bg-black', option: () => 'dark:bg-black dark:text-white', singleValue: () => 'dark:text-white'}}
                    />

                    {/* <select className="select-field" name='timeFormat' defaultValue={settings?.timeFormat ?? null}>
                      <option value="12">1:00 PM</option>
                      <option value="24">13:00</option>
                    </select> */}
                  </div>
                </div>
              </div>
              <div className="field-block mt-[30px]">
                <label className="field-label" style={{ color: theme == "dark" ? "white" : "", opacity: theme == "dark" ? 0.7 : '' }}>Date format</label>
                <div className="field-data">
                  <div className="filed-data-block" css={{
                    '.general-setting__option--is-selected': {
                      background: `linear-gradient(0deg, var(--accent-color), var(--accent-color)), #ffffff !important;`
                    }
                  }}>

                    <Select
                      onChange={(value) => handleChange(value, "dateFormat")}
                      options={dateFormatOptions}
                      value={
                        settings?.dateFormat ? dateFormatOptions.filter(option =>
                          option.label === settings?.dateFormat) : dateFormatOptions[0]
                      }
                      className="react-select"
                      classNamePrefix={"general-setting" || ""}
                      classNames={{control: () => 'dark:bg-black', menu: () => 'dark:bg-black', option: () => 'dark:bg-black dark:text-white', singleValue: () => 'dark:text-white'}}
                    />

                    {/* <select className="select-field" name='dateFormat' defaultValue={settings?.dateFormat ?? null}>
                      <option value="MM/DD/YYYY">MM/DD/YYYY</option>
                      <option value="YY/MM/DD">DD/MM/YYYY</option>
                    </select> */}
                  </div>
                </div>
              </div>

              <div className="field-block mt-[30px]">
                <label className="field-label" style={{ color: theme == "dark" ? "white" : "", opacity: theme == "dark" ? 0.7 : '' }}>Week Start</label>
                <div className="field-data">
                  <div className="filed-data-block" css={{
                    '.general-setting__option--is-selected': {
                      background: `linear-gradient(0deg, var(--accent-color), var(--accent-color)), #ffffff !important;`
                    }
                  }}  >

                    <Select
                      onChange={(value) => handleChange(value, "weekStart")}
                      options={weekStartOptions}
                      value={
                        settings?.weekStart ? weekStartOptions.filter(option =>
                          option.value === settings?.weekStart) : weekStartOptions[0]
                      }
                      selectedValue={settings?.weekStart}
                      className="react-select"
                      classNamePrefix={"general-setting" || ""}
                      classNames={{control: () => 'dark:bg-black', menu: () => 'dark:bg-black', option: () => 'dark:bg-black dark:text-white', singleValue: () => 'dark:text-white'}}
                    />


                    {/* <select className="select-field" name='weekStart' defaultValue={settings?.weekStart ?? null}>
                      <option value="Monday">Monday</option>
                      <option value="Tuesday">Tuesday</option>
                      <option value="Wednesday">Wednesday</option>
                      <option value="Thursday">Thursday</option>
                      <option value="Friday">Friday</option>
                      <option value="Saturday">Saturday</option>
                      <option value="Sunday">Sunday</option>
                    </select> */}
                  </div>
                </div>
              </div>

              <div className="field-block mt-[30px]">
                <label className="field-label" style={{ color: theme == "dark" ? "white" : "", opacity: theme == "dark" ? 0.7 : '' }}>Early Feature Access Code</label>
                <div className="field-data">
                  <input defaultValue={settings?.testingCode ?? ''} type="text" onInput={(e) => handleChange(e.target, "testingCode")} className='input-field filed-data-block testing-code-field dark:bg-black' />
                </div>
              </div>
              <KeyboardShortcuts fetchSettingData={fetchSettingData} settings={settings} theme={theme} />
              <div className="field-block mt-[30px]" >
                <h3 className="form-heading uppercase dark:text-white dark:opacity-70"> Integrations </h3>
                <Todoist fetchSettingData={fetchSettingData} settings={settings} theme={theme} colorPicker={theme == "dark" ? colorPickerDark : colorPicker} />
                {/* <GoogleCalendar fetchSettingData={fetchSettingData} settings={settings} theme={theme} colorPicker={theme == "dark" ? colorPickerDark : colorPicker} /> */}
              </div>
            </form>
          </div>
        </div>
      }
    </li>
  )
}

export default General